import TileVideo from './TileVideo'

export default TileVideo
// eslint-disable-next-line import/export
export * from './TileVideo'
